<template>
  <div class="container-filtros">
    <label v-if="flagLabel">{{ label }}</label>
    <div class="dropdown" :class="getClass">
      <div class="dropdown-head" @click="activeDropDown()">
        <p :class="selectOption == -1 || selectOption == 0 ? 'inactive' : ''">
          {{ getFechaTitular }}
        </p>
        <img
          src="../../../assets/imgs/icons/flecha-dark.svg"
          class="arrow"
          alt="icon"
        />
      </div>
      <div class="date-picker" :class="showCalendar ? 'show' : ''">
        <DatePicker
          class="vc-header"
          color="blue"
          @dayclick="dayclick"
          trim-weeks
          is-expanded
          :min-date="minDate ? new Date() : ''"
          :max-date="!minDate && maxDate ? new Date() : ''"
          v-model="fecha"
        ></DatePicker>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar";
import moment from "moment";

export default {
  name: "DropDown-Calendar",
  components: {
    DatePicker,
  },
  props: {
    placeholder: {
      type: String,
      default: moment().format("DD-MM-YYYY"),
    },
    flagLabel: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    selectOption: {
      type: Number,
      default: -1,
    },
    heigthModal: {
      type: Boolean,
      default: false,
    },
    fechaExterna: {
      type: String,
      default: moment().format("DD-MM-YYYY"),
    },
    minDate: {
      type: Boolean,
      default: true,
    },
    maxDate: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      showCalendar: false,
      info: 0,
      fecha: new Date(),
      fechaTitular: this.placeholder,
    };
  },
  computed: {
    getClass() {
      return {
        active: this.showDrop,
        "calendar-active": this.showCalendar,
        height50: this.heigthModal,
      };
    },
    getFechaTitular() {
      return this.fechaExterna;
    },
  },
  methods: {
    async activeDropDown() {
      event.stopPropagation();
      this.showDrop = !this.showDrop;
      this.showCalendar = !this.showCalendar;
      this.showDrop = !this.showDrop;
      this.$emit("activeCalendar", this.showCalendar, this.showDrop);
      if (this.showDrop) {
        window.addEventListener("click", () => {
          this.showDrop = false;
        });
      } else {
        window.removeEventListener("click", () => {
          this.showDrop = false;
        });
      }
    },
    dayclick(day) {
      let fechaSeleccionada = moment(day.id).format("YYYY-MM-DD");
      this.showCalendar = false;
      this.showDrop = false;
      this.$emit("actualizarFechas", fechaSeleccionada, this.showCalendar);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped>
.container-filtros {
  position: relative;
}
label {
  text-align: center;
  width: unset;
  padding: 0px 10px;
  letter-spacing: 0px;
  color: #707070;
  opacity: 1;
  margin-left: 30px;
  background: white;
  position: absolute;
  z-index: 2;
  top: -11px;
  font-size: 16px;
  opacity: 1;
  transition: all 0.4s;
}
.dropdown {
  display: flex;
  flex-direction: column;
  min-width: 170px;
  width: min-content;
  background-color: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-box-shadow: 0px 3px 6px #00000029;
  -moz-box-shadow: 0px 3px 6px #00000029;
  position: relative;
  border: 1px solid #404040;
  box-sizing: border-box;
}
.dropdown .dropdown-head {
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 15px;
  color: #707070;
  font-size: 16px;
  cursor: pointer;
}
.height50 .dropdown-head {
  height: 55px;
}
.height50 {
  width: 100%;
}
.dropdown .dropdown-head .arrow {
  width: 20px;
  transition: 0.3s all ease-in-out;
}
.dropdown.active .dropdown-head .arrow {
  transition: 0.3s all ease-in-out;
}
.inactive {
  opacity: 0.5;
}
.date-picker {
  position: absolute;
  right: 0;
  top: 60px;
  z-index: 6;
  background-color: #ffffff;
  color: #ffffff;
  border-radius: 6px;
  height: 0px;
  width: 0px;
  opacity: 0;
  pointer-events: none;
  transition: 0.3s all ease-in-out;
}
.date-picker.show {
  height: auto;
  width: 100%;
  opacity: 1;
  pointer-events: all;
  box-shadow: 0px 3px 6px #00000029;
  -webkit-box-shadow: 0px 3px 6px #00000029;
  -moz-box-shadow: 0px 3px 6px #00000029;
}
.v-application p {
  margin-bottom: 0;
}
@media (max-width: 767px) {
  .container-filtros {
    width: 100%;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown .dropdown-head {
    font-size: 14px;
  }
  label {
    font-size: 16px;
  }
  .date-picker {
    width: 100%;
  }
}
</style>
